import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ConfigService } from 'src/app/core/services/config/config.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
})
export class ScheduleComponent implements OnInit {
  searchWord:any;
  isLoading:boolean;
  dir:string;
  totalRecords: number;
  scheduleData:any;
  scheduleDate:any = null;
  cols: any[];
  showNewRequest:boolean = false;
  constructor(private router:Router,private helperService:HttphelperService,private cd:ChangeDetectorRef,private messageService: MessageService,
    private translate: TranslateService,public datepipe: DatePipe) {
    this.isLoading = false;
    this.totalRecords = 0;
    this.showNewRequest =  ConfigService.APPMainsettings.ShowNewRequest;
    let currentLnaguage =  localStorage.getItem('lang');
    if(currentLnaguage == null){
        this.dir = "ltr"; 
    }
    else
    {
      if(currentLnaguage == 'ar'){
        this.dir = "rtl"; 
      }
      else{
        this.dir = "ltr"; 
      }
    }
  }

  ngOnInit() {
      this.cols = [
          {field: 'DoctorName', header: 'DoctorName'},
          {field: 'ClinicName', header: 'ClinicName'},
          {field: 'ServiceName', header: 'ServiceName'},
          {field: 'AppointmentDateForSort', header: 'AppointmentDate'},
          {field: 'RequestStatusName', header: 'Status'},
          {field: 'RequestType', header: 'RequestType'}
      ];
  }
  loadScheduleData(event: LazyLoadEvent)
  {
    var scheduleDate = this.scheduleDate ?? "";
    if(scheduleDate != "")
    {
      scheduleDate = this.datepipe.transform( this.scheduleDate, 'dd/MM/yyyy');
    }
    let pageIndex = (event.first / event.rows) + 1;
    this.isLoading = true;
    this.cd.detectChanges();
    let patientId = localStorage.getItem('PatientId');
    var scheduleUrl = `/api/Queue/PatientQueues?PageSize=${event.rows}&pageid=${pageIndex}&filter=${this.searchWord || ''}&scheduleDate=${scheduleDate}&patId=${patientId}`;
    this.helperService.getRequest(scheduleUrl,true).subscribe(response => {
    if(response.Success)
    {
      this.scheduleData = response?.Data;
      this.totalRecords = response?.AllDataCount;
    }
    else{
      this.scheduleData = [];
      this.totalRecords = 0;
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:response.Message, life: 2000});
    }  
    this.isLoading = false;
   },
   error=>{
    this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
    this.isLoading = false;
    this.totalRecords = 0;
   })
  }
  onChangescheduleDate(value:any,dt :any){
    this.scheduleDate = value;
    this.loadScheduleData(dt);
  }
  openNewRequest():void
  {
    this.router.navigate(['/newrequest']);
  }
}
